import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {TeamService} from "@/service/TeamService.ts";
import {TeamResponse, TeamResponseData} from "@/model/response/team/TeamResponse.ts";
import {ReadTeamByWorkSpaceIdResponse} from "@/model/response/team/ReadTeamByWorkSpaceIdResponse.ts";

export type TeamState = {
    loading: boolean;
    TeamData: TeamResponseData[]
    TeamByWorkSpaceId: ReadTeamByWorkSpaceIdResponse["data"][]
}

const initialState: TeamState = {
    loading: false,
    TeamData: [],
    TeamByWorkSpaceId: []

}

const action = {
    read: createAsyncThunk("team/read", async (_, thunkAPI) => {
        return (await TeamService.read(thunkAPI)).data;
    })
}

const slice = createSlice({
    name: "Team",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.read.pending, (state) => {
                state.loading = true
            }).addCase(action.read.fulfilled, (state, action) => {
            const response = action.payload as TeamResponse
            state.loading = false
            if (response.responseCode == "00") {
                state.TeamData = response.data
            }
        })
    }
})

2

export const team = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
}